import { useTranslation } from 'react-i18next'

interface GroceryProgressProps {
  total: number
  ticked: number
}

export function GroceryProgress({ total, ticked }: GroceryProgressProps) {
  const { t } = useTranslation('home')
  const percentage = total > 0 ? Math.round((ticked / total) * 100) : 0

  return (
    <div
      className="px-4 py-3"
      role="progressbar"
      aria-valuenow={ticked}
      aria-valuemin={0}
      aria-valuemax={total}
      aria-label={t('progress.ariaLabel', { ticked, total })}
    >
      <div className="h-1.5 w-full rounded-full bg-gray-200 overflow-hidden">
        <div
          className="h-full rounded-full bg-primary transition-all duration-300"
          style={{ width: `${percentage}%` }}
        />
      </div>
      <p className="text-sm text-muted mt-1.5 text-center">
        {t('progress.items', { ticked, total })}
      </p>
    </div>
  )
}
